"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["exceptionCaught"] = "EXCEPTION_CAUGHT";
    ErrorCode["recordNotFound"] = "RECORD_NOT_FOUND";
    ErrorCode["notAllowed"] = "NOT_ALLOWED";
    ErrorCode["parentRecordNotFound"] = "PARENT_RECORD_NOT_FOUND";
    ErrorCode["childRecordNotFound"] = "CHILD_RECORD_NOT_FOUND";
    ErrorCode["existsCheckFail"] = "EXISTS_CHECK_FAIL";
    ErrorCode["contextInvalid"] = "CONTEXT_INVALID";
    ErrorCode["inputsInvalid"] = "INPUTS_INVALID";
    ErrorCode["schemaInvalid"] = "SCHEMA_INVALID";
    ErrorCode["queryStringInvalid"] = "QUERY_STRING_INVALID";
    ErrorCode["urlParamsInvalid"] = "URL_PARAMS_INVALID";
    ErrorCode["invalidExtendedInstance"] = "INVALID_EXTENDED_INSTANCE";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
//# sourceMappingURL=ErrorCode.js.map